module.exports = __webpack_public_path__ + "2ee651fd993570a49b1fe5ca86a41f01.png";